import { useCallback, useState } from "react";
import { useGlobalContext } from "../Context/GlobalContext";

const useGoogleLocationApi = () => {
  // =========================================================
  // PACKKY API
  // =========================================================

  const { packkyApi } = useGlobalContext();

  const [placesAutoCompletionLoading, setPlacesAutoCompletionLoading] =
    useState(false);

  const [getLatLongByPlaceIdLoading, setGetLatLongByPlaceIdLoading] =
    useState(false);

  // =========================================================
  // PLACES AUTO COMPLETION
  // =========================================================

  const placesAutoCompletionApi = useCallback(
    async ({ input, latitude = 0, longitude = 0, radius = 50000 }) => {
      try {
        setPlacesAutoCompletionLoading(true);

        const payload = {
          input: String(input || "").trim(),

          latitude: Number(latitude || 0),

          longitude: Number(longitude || 0),

          radius: Number(radius || 50000),
        };

        console.log("===== PACKKY placesAutoCompletion Payload =====", payload);

        const response = await packkyApi.post(
          "/Google/v1.0/placesAutoCompletion",
          payload,
        );

        console.log(
          "===== PACKKY placesAutoCompletion Response =====",
          response?.data,
        );

        return response?.data || null;
      } catch (error) {
        console.error(
          "PACKKY Places Auto Completion Error:",
          error?.response?.data || error,
        );

        return null;
      } finally {
        setPlacesAutoCompletionLoading(false);
      }
    },
    [packkyApi],
  );

  // =========================================================
  // GET LAT LONG BY PLACE ID
  // =========================================================

  const getLatLongByPlaceIdApi = useCallback(
    async ({ placeId }) => {
      try {
        setGetLatLongByPlaceIdLoading(true);

        const payload = {
          placeId: String(placeId || "").trim(),
        };

        if (!payload.placeId) {
          return null;
        }

        console.log("===== PACKKY getLatLongByPlaceId Payload =====", payload);

        const response = await packkyApi.post(
          "/Google/v1.0/getLatLongByPlaceId",
          payload,
        );

        console.log(
          "===== PACKKY getLatLongByPlaceId Response =====",
          response?.data,
        );

        return response?.data || null;
      } catch (error) {
        console.error(
          "PACKKY Get Lat Long By Place Id Error:",
          error?.response?.data || error,
        );

        return null;
      } finally {
        setGetLatLongByPlaceIdLoading(false);
      }
    },
    [packkyApi],
  );

  return {
    placesAutoCompletionLoading,
    getLatLongByPlaceIdLoading,

    placesAutoCompletionApi,
    getLatLongByPlaceIdApi,
  };
};

export default useGoogleLocationApi;
